// src/components/UpgradeModal.tsx

import { X, Crown, Check, Sparkles } from 'lucide-react';
import { STANDARD_PLAN_BENEFITS } from '@/lib/planFeatures';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;  // 制限された機能名
}

export function UpgradeModal({ isOpen, onClose, feature }: UpgradeModalProps) {
  if (!isOpen) return null;

  const handleUpgrade = () => {
    // TODO: Stripe決済ページへ遷移
    // window.location.href = '/upgrade';
    alert('決済機能は準備中です');
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* ヘッダー */}
        <div className="bg-gradient-to-r from-amber-400 to-orange-500 px-6 py-8 text-white relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
          
          <div className="flex items-center gap-3 mb-3">
            <div className="p-2 bg-white/20 rounded-full">
              <Crown className="w-8 h-8" />
            </div>
            <div>
              <h2 className="text-2xl font-bold">Standardプラン</h2>
              <p className="text-white/90 text-sm">すべての機能をアンロック</p>
            </div>
          </div>
          
          <div className="flex items-center gap-2 mt-4 bg-white/20 rounded-lg px-4 py-2">
            <Sparkles className="w-5 h-5" />
            <span className="text-sm font-medium">
              「{feature}」はStandardプランで利用できます
            </span>
          </div>
        </div>

        {/* 特典リスト */}
        <div className="p-6">
          <p className="text-sm font-medium text-gray-700 mb-4">
            Standardプランに含まれる機能
          </p>
          <ul className="space-y-3 mb-6">
            {STANDARD_PLAN_BENEFITS.map((benefit) => (
              <li key={benefit} className="flex items-center gap-3">
                <div className="flex-shrink-0 w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
                  <Check className="w-3 h-3 text-green-600" />
                </div>
                <span className="text-gray-700">{benefit}</span>
              </li>
            ))}
          </ul>

          {/* 価格表示 */}
          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <div className="flex items-baseline gap-2">
              <span className="text-3xl font-bold text-gray-900">¥980</span>
              <span className="text-gray-600">/ 月</span>
            </div>
            <p className="text-sm text-gray-500 mt-1">
              年払いなら ¥9,800/年（2ヶ月分お得）
            </p>
          </div>

          {/* ボタン */}
          <div className="space-y-3">
            <button
              onClick={handleUpgrade}
              className="w-full px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl font-semibold hover:from-amber-600 hover:to-orange-600 transition-all duration-200 shadow-lg shadow-orange-500/30"
            >
              Standardプランにアップグレード
            </button>
            <button
              onClick={onClose}
              className="w-full px-6 py-3 text-gray-600 hover:text-gray-800 font-medium transition-colors"
            >
              あとで検討する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
